import { OperacoesWebAPI, StringsCookie, StringsSessionStorage } from './../../utils/global';
import api from '../api'
import Usuario from '../../models/usuario';
import { EPerfilCodigo } from '../../components/enums/perfil.enum';
export const loginService = {

    validarUsuario: (usuario: any): Promise<any | Usuario> => {
        return api.post(`${OperacoesWebAPI.Login}/validarusuario?`, usuario)
            .then((res) => {
                sessionStorage.setItem("usuarioLogado", JSON.stringify(res.data));
                sessionStorage.setItem("usuarioLogado", JSON.stringify(res.data));
                sessionStorage.setItem(StringsSessionStorage.ExpirationToken,res.data.expiration)
                sessionStorage.setItem(StringsCookie.CustomToken,res.data.access_token)
                // setCookie(StringsCookie.CustomToken, res.data.access_token, res.data.expiration)
                return res.data
            })
            .catch(err => err)
    },

    getPermissoes: (usuarioID: number) => {
        return api.get(`${OperacoesWebAPI.Login}/getpermissoes?usuarioID=${usuarioID}`)
            .then((res) => res)
            .catch(err => err)
    },

    selecionarPerfil: (grupoID: number, geoEstruturaID:number) => {
        return api.post(`${OperacoesWebAPI.Login}/selecionarperfil?grupoID=${grupoID}&geoEstruturaID=${geoEstruturaID}`)
            .then((res) => {
                sessionStorage.setItem(StringsSessionStorage.ExpirationToken,res.data.expiration)
                sessionStorage.setItem(StringsCookie.CustomToken,res.data.access_token)
                // setCookie(StringsCookie.CustomToken, res.data.access_token, res.data.expiration)
                return res
            })
            .catch(err => err)
    },
    getDominios: () => {
        return api.get(`${OperacoesWebAPI.Login}/getdominios`).then((response) => {
            return response.data
        })
    },
    renewToken: () => {
        return api.post(`${OperacoesWebAPI.Login}/renewToken`)
            .then((res) => {                
                sessionStorage.setItem(StringsSessionStorage.ExpirationToken,res.data.expiration)
                sessionStorage.setItem(StringsSessionStorage.CustomToken,res.data.access_token)
               // setCookie(StringsCookie.CustomToken, res.data.access_token, res.data.expiration)
                return res
            })
            .catch(err => err)
    },

    ehAdministrador: (grupoID: string): boolean => {
        return grupoID === EPerfilCodigo.AdministradorGeralDesenvolvimento.toString() ||
            grupoID === EPerfilCodigo.AdministradorGeralHomologacao.toString() ||
            grupoID === EPerfilCodigo.AdministradorGeralProducao.toString()
    },

    ehGestor: (grupoID: string): boolean => {
        return grupoID === EPerfilCodigo.GestorEstadualDesenvolvimento.toString() ||
            grupoID === EPerfilCodigo.GestorEstadualHomologacao.toString() ||
            grupoID === EPerfilCodigo.GestorEstadualProducao.toString()
    },

    ehTecnicoMunicipal: (grupoID: string): boolean => {
        return grupoID === EPerfilCodigo.TecnicoMunicipalDesenvolvimento.toString() ||
            grupoID === EPerfilCodigo.TecnicoMunicipalHomologacao.toString() ||
            grupoID === EPerfilCodigo.TecnicoMunicipalProducao.toString()
    }

}